import React from "react";
import Pagination from "./Pagination";
import SearchField from "./SearchField";
import Status from "./Status";
import * as XLSX from 'xlsx';
import { ReactComponent as Plus } from "../assets/icons/circle-plus.svg";


export default function List({
  data,
  query,
  updateQuery,
  status,
  updateStatus,
  statusList,
  updatePage,
  onNew,
  Item,
  renderBeforeContent,
  onReadExcelInput,
  excelExampleHeaders,
}) {

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onload = (event) => {
      const workbook = XLSX.read(event.target.result, { type: 'binary' });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const sheetData = XLSX.utils.sheet_to_json(sheet);

      onReadExcelInput(sheetData);
    };

    reader.readAsArrayBuffer(file);
  };

  const downloadExcelExample = () => {
    const entries = excelExampleHeaders.map(d => ([ d, "" ]));
    const obj = Object.fromEntries(entries);
    const data = [ obj ];

    // Create new workbook
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(data);
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, "example.xlsx", { compression: true });
  }

  return (
    <>
      <div className="flex items-center justify-between mb-10">
        { !!updateQuery &&
          <SearchField value={query} update={updateQuery} />
        }
        <div className="flex gap-12">
          { !!statusList &&
            <Status value={status} update={updateStatus} items={statusList} />
          }
          {onNew ? (
            <button style={{ color: "white" }} onClick={onNew}>
              <Plus className="fill-primary h-10 w-10" />
            </button>
          ) : null}
          { !!onReadExcelInput &&
            <div className="flex flex-col align-center justify-center">
              <label className="text-white hover:text-secondary text-base font-semibold hover:cursor-pointer">
                <input 
                  type="file" 
                  accept=".xls,.xlsx"
                  onChange={handleFileUpload}
                  className="hidden"
                />
                Importar Excel
              </label>
            </div>
          }
          { (!!excelExampleHeaders && excelExampleHeaders.length > 0) &&
            <div className="flex flex-col align-center justify-center">
              <label className="text-white hover:text-secondary text-base font-semibold hover:cursor-pointer">
                <button onClick={downloadExcelExample} className="hidden"/>
                Exemplo Excel
              </label>
            </div>
          }
        </div>
      </div>
      { !!renderBeforeContent && renderBeforeContent }
      <div className="grid grid-cols-2 gap-6 mb-10">
        {data.content.map((i) => Item(i))}
      </div>
      { !!updatePage &&
        <Pagination data={data} query={(page) => updatePage(page)} />
      }
    </>
  );
}
